import React from 'react';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';

import { Routes, Route } from 'react-router-dom';

import DashboardHome from './DashboardHome';
import BotControl from './BotControl';
import WalletStats from './WalletStats';
import LivePerformance from './LivePerformance';
import BotLogs from './BotLogs';
import DashboardSettings from './DashboardSettings';
import DashboardSupport from './DashboardSupport';
import FirstPage from './FirstPage';
import UserProfile from './UserProfile'; // ✅ Step 1: Import

const TradingDashboard = () => {
  return (
    <div className="flex h-screen bg-[#003D38] text-[#CE9242] font-poppins">
      <Sidebar />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />

        <main className="p-6 overflow-y-auto">
          <Routes>
            <Route index element={<DashboardHome />} />
            <Route path="bot-control" element={<BotControl />} />
            <Route path="wallet" element={<WalletStats />} />
            <Route path="performance" element={<LivePerformance />} />
            <Route path="logs" element={<BotLogs />} />
            <Route path="settings" element={<DashboardSettings />} />
            <Route path="support" element={<DashboardSupport />} />
            <Route path="first-page" element={<FirstPage />} />
            <Route path="user" element={<UserProfile />} /> {/* ✅ Step 2: Route Added */}
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default TradingDashboard;
